import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DashboardShell, TileSection, listCount, useRefreshKey, useAnyVisible } from '../../shared/LiveDashboard';

// Inventory Dashboard: a live starter (shared/LiveDashboard.js).
const KEY_FIGURES = [
  { key: 'products', label: 'Active Products', screen: 'products', icon: 'Stock On Hand', count: listCount('/api/products', { status: 'active', limit: 1 }), to: '/products', state: { initialFilters: { status: 'active' } } },
];
const QUICKBOOKS = [
  { key: 'qbo-unmatched', label: 'Not Linked to QuickBooks', screen: 'products', icon: 'Outstanding Invoices', count: listCount('/api/products', { status: 'active', quickbooks: 'unmatched', limit: 1 }), to: '/products', state: { initialFilters: { status: 'active', quickbooks: 'unmatched' } } },
  { key: 'qbo-attention', label: 'QuickBooks Link Needs Attention', screen: 'products', icon: 'Outstanding Invoices', count: listCount('/api/products', { status: 'active', quickbooks: 'needs_attention', limit: 1 }), to: '/products', state: { initialFilters: { status: 'active', quickbooks: 'needs_attention' } } },
];
// Stands in for the tiles until the Brand Types load, so the "no cards"
// wording knows the Brands screen counts.
const BRANDS_SCREEN = [{ screen: 'inventory-brands' }];

// One tile per active Brand Type: its active Brands, opening Brands
// filtered to it.
function useBrandTypeTiles() {
  const [tiles, setTiles] = useState([]);
  useEffect(() => {
    axios.get('/api/brand-types', { params: { status: 'active' } })
      .then((res) => setTiles((res.data.data || []).map((type) => ({
        key: `brand-type-${type.id}`,
        label: type.name,
        screen: 'inventory-brands',
        icon: 'Reports Viewed',
        count: listCount('/api/brands', { status: 'active', brand_type_id: type.id }),
        to: `/inventory-brands?brand_type=${type.id}`,
        state: { initialFilters: { status: 'active' } },
      }))))
      .catch(() => setTiles([]));
  }, []);
  return tiles;
}

function InventoryDashboard() {
  const [refreshKey, refresh] = useRefreshKey();
  const brandTypeTiles = useBrandTypeTiles();
  const any = useAnyVisible(KEY_FIGURES, QUICKBOOKS, BRANDS_SCREEN);
  return (
    <DashboardShell
      title="Inventory Dashboard"
      description={any ? 'Products, Brands by type, and QuickBooks links.' : 'Your Roles don’t include any of this dashboard’s cards.'}
      onRefresh={refresh}
    >
      <TileSection title="Key Figures" tiles={KEY_FIGURES} refreshKey={refreshKey} />
      <TileSection title="Active Brands by Type" tiles={brandTypeTiles} refreshKey={refreshKey} />
      <TileSection title="QuickBooks" tiles={QUICKBOOKS} refreshKey={refreshKey} />
    </DashboardShell>
  );
}

export default InventoryDashboard;
